<public>

  <div id="box-copter-hero-3d">
      <div id="box-copter-hero-3d-form-wrapper" fxLayout="column" fxLayoutAlign="start start" fxFlex="100">
          <div id="box-copter-hero-3d-form">
              <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="start start">

                  <div fxLayout="column" fxFlex="100">
                    <div>

                      <div style="padding: 12px;" class="jumbotron text-center" fxLayout="row" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column">
                        <div fxFlex="20" fxLayout="column">
                          <h1 class="subHeader" style="line-height: 60px;">
                            Box Copter Hero 3D
                          </h1>
                          <div class="image_icon" style="padding: 12px;">
                            <img style="width: 200px; height: 200px; margin-bottom: 24px;" src="assets/images/game-icons/box-copter-hero-3d-icon.png">
                          </div>
                        </div>
                        <div fxFlex="80" fxLayout="column">
                          <h1>Overview</h1>
                          <em class="box-copter-hero-text" style="display: inline-block !important; color: #fff; font-size: 24px; line-height: 76px !important; font-family: 'Raleway', sans-serif;">
                            <img style="width: 50px; height: 50px;" src="assets/images/large-quote-start.png" />
                            The box copter enters into the 3D world in this follow up to Box Copter Hero. Control the box copter by tapping to change direction, using momentum to ascend an endless tower filled with obstacles. The box copter runs on fuel canisters you need to collect. Go for the highest score!
                            <img style="width: 50px; height: 50px;" src="assets/images/large-quote-end.png" />
                          </em>
                          <mat-divider style="border-top-width: 1px; border-top-color: #fff;"></mat-divider>
                          <h1>
                            External Links
                          </h1>
                          <a (click)="navigate('https://www.behance.net/gallery/117776997/Box-Copter-Hero-3D')" style="padding: 6px;"><img src="assets/images/icons/behance.png" style="width: 32px; height: 32px;" /></a>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</public>
